import React from "react";
import { useLists } from "../../context/listContext";
import { DashBox, DashMain } from "../../styles/index.sty";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Attributes = () => {
  const {
    countList,
    fetchCountsList
  } = useLists();

  useEffect(() => {
    fetchCountsList();
  }, [])
  const navigate = useNavigate();
  // console.log(brandsList);
  return (
    <DashMain>
      <Tooltip title="Visit Finishes Page">
        <DashBox onClick={() => navigate("/finishes")}>
          <div>
            <h2>Finishes</h2>
            <br />
            <h3>
              Total Count: <span>{countList[0]?.finish_count}</span>
            </h3>
          </div>
          <div>
            <AdminPanelSettingsIcon />
          </div>
        </DashBox>
      </Tooltip>
      <Tooltip title="Visit Sizes Page">
        <DashBox onClick={() => navigate("/sizes")}>
          <div>
            <h2>Sizes</h2>
            <br />
            <h3>
              Total Count: <span>{countList[0]?.size_count}</span>
            </h3>
          </div>
          <div>
            <GroupIcon />
          </div>
        </DashBox>
      </Tooltip>
      <Tooltip title="Visit Storages Page">
        <DashBox onClick={() => navigate("/storages")}>
          <div>
            <h2>Storages</h2>
            <br />
            <h3>
              Total Count: <span>{countList[0]?.storage_count}</span>
            </h3>
          </div>
          <div>
            <CategoryIcon />
          </div>
        </DashBox>
      </Tooltip>
      <Tooltip title="Visit Colors Page">
        <DashBox onClick={() => navigate("/colors")}>
          <div>
            <h2>Colors</h2>
            <br />
            <h3>
              Total Count: <span>{countList[0]?.color_count}</span>
            </h3>
          </div>
          <div>
            <CategoryIcon />
          </div>
        </DashBox>
      </Tooltip>
      <Tooltip title="Visit Materials Page">
        <DashBox onClick={() => navigate("/materials")}>
          <div>
            <h2>Materials</h2>
            <br />
            <h3>
              Total Count: <span>{countList[0]?.material_count}</span>
            </h3>
          </div>
          <div>
            <CategoryIcon />
          </div>
        </DashBox>
      </Tooltip>
    </DashMain>
  );
};

export default Attributes;
